import * as Strategy from '#/unified-rfqs/ui/rfqs/strategy-functions';
import * as Product from '#/products/domain';
import { State } from '#/unified-rfqs/ui/rfq-builder/store';
import { isHedgeLeg, validateHedgeLegQuantity } from '../leg-functions';
import {
  HEDGE_ON_MULTI_PRODUCT_MESSAGE,
  spansMultipleProducts,
} from '../multi-product';

export default function hedgeView(
  selectedStrategyCode: State['strategyCode'],
  legs: State['legs'],
  isOrderBook: boolean,
) {
  if (spansMultipleProducts(legs)) {
    return { isDisabled: true, errorMsg: HEDGE_ON_MULTI_PRODUCT_MESSAGE };
  }

  const isCustomStrategy = selectedStrategyCode == null;

  // Use the first NON-hedge leg's product, not legs[0]: leg removal
  // re-indexes the array, so a hedge leg (normally appended last) can end up
  // at index 0 once the original leg 0 is removed. legs[0] would then be the
  // hedge product, and Product.supportsHedging would check the wrong side.
  const productCode = legs.find((leg) => !isHedgeLeg(leg))?.productCode;

  const isSupported =
    (isCustomStrategy || Strategy.supportsHedging(selectedStrategyCode)) &&
    Product.supportsHedging(productCode);

  if (!isSupported) return { isDisabled: true };

  if (!isOrderBook) {
    const hedgeLegs = legs.filter(isHedgeLeg);
    for (const hedgeLeg of hedgeLegs) {
      const { isValid, errorMsg } = validateHedgeLegQuantity(hedgeLeg);
      if (!isValid) return { isDisabled: false, submitMsg: errorMsg };
    }
  }

  if (isCustomStrategy) {
    return {
      isDisabled: false,
      errorMsg: getErrorMessage(legs),
    };
  }
  return { isDisabled: false };
}

function getErrorMessage(legs: State['legs']): string | undefined {
  const optionLegs = legs.filter((leg) => leg.kind === 'OPTION');

  if (optionLegs.length === 0) {
    return 'You must add at least one Option leg to add a future hedge leg.';
  }

  return undefined;
}
